import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=38eb8682&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=38eb8682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb8682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38eb8682')) {
      api.createRecord('38eb8682', component.options)
    } else {
      api.reload('38eb8682', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=38eb8682&scoped=true&", function () {
      api.rerender('38eb8682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS8CvN2eu39c/JS/teamMember.vue"
export default component.exports